import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import {
  Navbar,
  Sidebar,
  Cursor,
  CurText,
  Loader,
} from "./components/Components";
import { Home, AboutPage, Contact, ErrorPage } from "./pages/Pages";
import { useLocation } from "react-router-dom";

const App = () => {
  const [loadingCounter, setLoadingCounter] = useState(0);
  const location = useLocation();

  useEffect(() => {
    setLoadingCounter(0);

    const interval = setInterval(() => {
      setLoadingCounter((prev) => {
        if (prev < 100) {
          return prev + 1;
        } else {
          clearInterval(interval);
          setLoadingCounter(false);
          return 100;
        }
      });
    }, 20); // Adjust the interval duration as needed

    return () => clearInterval(interval);
  }, [location]);

  if (loadingCounter !== false) {
    return <Loader loadingCounter={loadingCounter} />;
  }
  return (
    <>
      <Cursor />
      <CurText />
      <Navbar />
      <Sidebar />
      <Switch location={location} key={location.pathname}>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/about">
          <AboutPage />
        </Route>
        <Route exact path="/contact">
          <Contact />
        </Route>
        <Route path="*">
          <ErrorPage />
        </Route>
      </Switch>
    </>
  );
};
export default App;
